import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * ApiBaseInterceptor
 * 
 * Intercepts HTTP requests and prepends the API_URL from environment
 * to relative API paths (those starting with 'api/').
 * 
 * This allows the client to make requests to a separate API server
 * via FQDN when the client and API are hosted separately.
 * 
 * Examples:
 * - 'api/patients' -> 'https://api.medicai.co.za/api/patients'
 * - 'https://external-api.com/data' -> 'https://external-api.com/data' (unchanged)
 * - '/assets/image.png' -> '/assets/image.png' (unchanged)
 */
@Injectable()
export class ApiBaseInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept relative API paths (starting with 'api/')
    // Skip absolute URLs (already have protocol) and other paths
    if (!request.url.startsWith('api/')) {
      return next.handle(request);
    }

    // Check if API_URL is configured
    if (!environment.API_URL) {
      console.warn('ApiBaseInterceptor: API_URL not configured in environment');
      return next.handle(request);
    }

    // Remove trailing slash from API_URL if present
    const baseUrl = environment.API_URL.replace(/\/$/, '');
    
    // Construct the full URL
    const fullUrl = `${baseUrl}/${request.url}`;

    // Clone the request with the new URL
    const modifiedRequest = request.clone({
      url: fullUrl
    });

    return next.handle(modifiedRequest);
  }
}

